<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="8">
        <b-card :header="caption">
          <b-row>
            <b-col cols="2">
              <b-form-group label="Mailbox">
                <b-form-input type="text" class="form-control" v-model="mailbox.mailbox" :readonly="true" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group label="Full Name">
                <b-form-input type="text" class="form-control" v-model="mailbox.fullname" :readonly="!$can('update', 'voicemail')" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group label="E-Mail Address">
                <b-form-input type="text" class="form-control" v-model="mailbox.email" :readonly="!$can('update', 'voicemail')" />
              </b-form-group>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-btn v-if="$can('update', 'voicemail')" size="sm" variant="primary" @click="save">Save</b-btn>
            <b-btn v-if="$can('delete', 'voicemail')" class="ml-1" size="sm" variant="danger" @click="del">Delete</b-btn>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'mailbox',
  computed: {
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      caption: 'Mailbox',
      mailbox: {
        id: null,
        mailbox: null,
        fullname: null,
        email: null
      },
    }
  },
  methods: {
    async save () {
      const id = this.$route.params.id

      if (this.mailbox.email.length === 0) {
        this.mailbox.email = null
      }

      const { data } = await this.$axios.put(`/v1/voicemail/mailboxes/${id}`, this.mailbox)
      Object.assign(this.mailbox, data)
      await this.$store.dispatch('account/getMailboxes')
      this.$snotify.success('Mailbox Saved')
    },
    async del () {
      const id = this.$route.params.id
      await this.$axios.delete(`/v1/voicemail/mailboxes/${id}`)
      this.$snotify.success('Mailbox Deleted')
      this.$router.push({ path: '/voicemail' })
    },
    getMailbox (id) {
      this.$axios.get(`/v1/voicemail/mailboxes/${id}`).then(({ data }) => {
        Object.assign(this.mailbox, data)
      })
    },
  },
  created () {
    this.getMailbox(this.$route.params.id)
  },
}
</script>


